import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, Injector } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgMultiSelectDropDownModule } from './components/search-select';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
/* define comonenets here **/
import { MainComponent } from './components/main-component/main.component';
import { FormQuestionComponent } from './components/form/form-question.component';
import { FormComponent } from './components/form/form.component';
import { DataGridPaginationComponent } from './components/data-grid-pagination/data-grid-pagination.component';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { UiEngineComponent } from './components/ui-engine/ui-engine.component';
import { ResourcePopupComponent } from './components/resource-popup/resource-popup.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { MultiDropdownComponent } from './components/multi-dropdown/multi-dropdown.component';
import { CompositeArrayObjectComponent } from './components/composite-array/composite-array-object.component';
import { CompositeArrayComponent } from './components/composite-array/composite-array.component';
import { FormWithGridComponent } from './components/form-with-grid/form-with-grid.component';
import { PopUpOverGridWithControlsComponent } from './components/dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { InputButtonComponent } from './components/input-button/input-button.component';
import { InputButtonPopupComponent } from './components/input-button/input-button-popup.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { DropdownObjectComponent } from './components/dropdown/dropdown-object.component';
import { ResourceBannerComponent } from './components/resource-banner/resource-banner.component';
import { LanguageSelectionComponent } from './components/language-selection/language-selection.component';
import { CloseOverlayDirective } from './directive/close-overlay.directive';
import { InclusionExclusionComponent } from './components/inclusion-exclusion/inclusion-exclusion.component';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
/* define comonenets here **/

/** define services here */
import { FormService } from './components/form/form.service';
import { UtilService } from './services/util.service';
import { QuestionControlService } from './components/form/question-control.service';
import { SmartModalService } from './services/smart-modal.service';
import { ModalService } from './services/modal.service';
import { ToastrModule } from 'ngx-toastr';
import { AlertsService } from './services/alerts.service';
import { LoaderService } from './services/loader.service';
import { CommonResolverService } from './services/common-resolver.service';
import { TabsService } from './services/tabs.service';
import { KeysPipe } from './pipes/key.pipe';
import { ApplicationInitService } from './services/application-init.service';
import { HandleRouteComponent } from './handle-route.component';
import { BaseComponent } from './base.component';
import { DialogModule } from './components/dialog/dialog.module';
import { CommunicationService } from './services/communication.service';
import { ShareMultiDropDownData } from './components/search-select/multi-select.service';
import { HideMenuOverlay } from './directive/hideMenuOverlay.directive';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { DynamicPopUpComponent } from './components/data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { NgxDaterangepickerMd } from './components/daterangepicker/daterangepicker.module';
import { exportImportFilesService } from './services/exportImportFiles.service';
import { SimpleDataTableComponent } from './components/simple-data-table/simple-data-table.component';
import { StatusService } from './services/status.service';
import { CurrencyPipe } from './pipes/currency.pipe';
import { IcdSearchComponent } from '../base/components/icd-search/icd-search.component';
import { QuickDownloadComponent } from '../base/components/quick-download/quick-download.component';

/************* CORE UI ************/
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
const APP_CONTAINERS = [
  BaseComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from './layout/coreui';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimePickerModule } from './components/timepicker/timepicker.module';
import { AsyncValidationService } from './components/form/async-validation.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DateTimeFilterComponent } from './components/datetimefilter/date-time-filter.component';
import { DateTimeFilterService } from './components/datetimefilter/date-time-filter.service'
import { FormViewComponent } from './components/form-view/form-view.component';
import { FormViewItemComponent } from './components/form-view/form-view-item.component';
import { DashBoardComponent } from './components/dash-board/dash-board.component';
import { FormGridComponent } from './components/form-grid/form-grid.component';
import { FormDirective } from './components/form/form.directive';
import { OnCreate } from './directive/onItemRender.directive';
import { BaseSharedModule } from './shared/base-shared.module';
import { ImageViewerComponent } from './components/viewer/image-viewer/image-viewer.component';
import { ToggleFullscreenDirective } from './components/viewer/image-viewer/fullscreen.directive';
import { ViewTemplateComponent } from './components/template/view-template/view-template.component';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { SafeHtml } from './pipes/safeHtml.pipe';
import { OrderByPipe } from './pipes/orderBy.pipe';
import { DocumentViewerComponent } from './components/viewer/document-viewer/document-viewer.component';
import { ScrollDirective } from './directive/scroll.directive';
import { DateTimeFormatPipe } from './pipes/date-time-format.pipe';
import { UserProfileComponent } from './components/user/user-profile/user-profile.component';
import { TranslateModule } from './pipes/translate.module';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { TagInputComponent } from './components/form/tag-input/tag-input.component';
import { WidgetCardComponent } from './components/dash-board/components/widget-card/widget-card.component';
import { WidgetComponent } from './components/dash-board/components/widget/widget.component';
import { ChartGroupComponent } from './components/dash-board/components/chart-group/chart-group.component';
import { DataGridWidgetComponent } from './components/dash-board/components/data-grid-widget/data-grid-widget.component';
import { ChartService } from './components/dash-board/services/chart.service';
import { BookmarksComponent } from './components/bookmarks/bookmarks.component';
import { EditableTableComponent } from './components/editable-table/editable-table.component';
import { LabelControl } from './directive/label.directive';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { editableGridService } from './components/dynamic-Grid-with-control/editableGrid.service';
import { RatingComponent } from './components/rating/rating.component';
import { ViewResourceComponent } from './components/view-resource/view-resource.component';
import { ScoreComponent } from './components/score/score.component';
import { PullableComponent } from './components/pullable/pullable.component';
import { scrollOverlayDirective } from './directive/number-scroll.directive';
import { FilterComponent } from './components/filter/filter.component';
import { FilterService } from './services/filter.service';
import { EditableGridComponent } from './components/editable-grid/editable-grid.component';
import { ThumbViewerComponent } from './components/viewer/thumb-viewer/thumb-viewer.component';
import { NumberDirective } from './directive/numbers-only.directive';
import { TncComponent } from './components/tnc/tnc.component';
import { EmrTemplateViewComponent } from './components/emr-template-view/emr-template-view.component';
import { EditableGridWithBannerComponent } from './components/editable-grid-with-banner/editable-grid-with-banner.component';
import { RangeComponent } from './components/range/range.component';
import { PopupEditableGridWithBannerComponent } from './components/popup-editable-grid-with-banner/popup-editable-grid-with-banner.component';
import { EditableGridWithBannerService } from './components/editable-grid-with-banner/editable-grid-with-banner.service';
import { PDFViewerComponent } from './components/viewer/pdf-viewer/pdf-viewer.component';
import { EulaComponent } from './components/eula/eula.component';
import { DiacomViewerComponent } from './components/viewer/diacom-viewer/diacom-viewer.component';
import { CartComponent } from './components/cart/cart.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { PopupFormComponent } from './components/popupform/popupform.component';
import { DateTimeViewComponent } from './components/date-time-view/date-time-view.component';
import { NgxModalDraggableDirective } from './directive/draggable.directive';
import { DashboardMasterComponent } from './components/dashboard-master/dashboard-master.component';
import { DashboardSidebarComponent } from './components/dashboard-sidebar/dashboard-sidebar.component';
import { CountComponent } from './components/dash-board/components/count/count.component';
import { GridsterModule } from 'angular-gridster2';
import { TextareaResizeDirective } from './directive/textarea-resize.directive';
import { DynamicDashboardComponent } from './components/dynamic-dashboard/dynamic-dashboard.component';
import { CompositeChartComponent } from './components/dash-board/components/composite-chart/composite-chart.component';
import { TokenComponent } from './components/token-system/token.component';
import { PopUIEngineComponent } from './components/pop-uiengine/pop-uiengine.component';
import { ComplexSearchComponent } from './components/complex-search/complex-search.component';
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgMonthPickerComponent } from './components/monthyear-picker/ng-month-picker.component';
import { ClickOutsidemonthyearDirective } from './directive/click-outside.directive';
import { MonthYearFormatPipe } from './pipes/month-year-format.pipe';
import { MonthYearViewComponent } from './components/month-year-view/month-year-view.component';
import { AdvanceSearchComponent } from './components/advance-search/advance-search.component';
import { PatientUhidMergeSearchComponent } from './components/patient-uhid-merge-search/patient-uhid-merge-search.component';
import { ImageCropperComponent } from './components/image-cropper/component/image-cropper.component';
import { DownloadPopupComponent } from './components/data-grid/download-popup/download-popup.component';
import { DownloadInfoComponent } from './components/data-grid/download-info/download-info.component';
import { EncounterpopupComponent } from './components/misc/encounterPopup/encounterpopup.component';
import { DataGridRowEditComponent } from './components/data-grid-row-edit/data-grid-row-edit.component';
import { AsideUiEngineComponent } from './components/aside-ui-engine/aside-ui-engine.component';
import { AsideBarService } from './services/asideBar.service';
import { SearchPatientComponent } from './components/misc/searchPatient/search-patient.component';
import { DialogConfig } from './components/dialog/dialog-config';
import { DialogRef } from './components/dialog/dialog-ref';
import { PatientPopupComponent } from './components/patient-popup/patient-popup.component';
import { ShowPdfComponent } from './components/file-uploader/show-pdf/show-pdf.component';
import { DocumentPipe } from './pipes/document.pipe';
import { MapValuePipe } from './pipes/map-value.pipe';
import { MaskPipe } from './pipes/mask.pipe';
import { AppService } from './shared/services/app.service';
import { DocumentWithThumbnailComponent } from './components/document-with-thumbnail/document-with-thumbnail.component';
import { SafeStyleHtml } from './pipes/safeStyleHtml.pipe';
import { CommonViewerComponent } from './components/viewer/common-viewer/common-viewer.component';
import { ManageFilterComponent } from './components/data-grid/manage-filter/manage-filter.component';
import { DynamicTableComponent } from './components/dynamic-table/dynamic-table.component';
import { AppAlertComponent } from './components/app-alert/app-alert.component';
import { BaseChartDirective } from './directive/chart/base-chart.directive';
import { IsMobileEditableGridComponent } from './components/is-mobile-editable-grid/is-mobile-editable-grid.component';
import { MultipleFormComponent } from './multiple-form/multiple-form.component';
import { GetHeightPipe } from './pipes/get-height.pipe';
import { DocumentViewerWithThumbnailComponent } from './components/document-viewer-with-thumbnail/document-viewer-with-thumbnail.component';
import { AddressPipe, FacilityObjPipe, PropertyPipe } from './pipes/utills.pipe';
import { TemplateInterceptorComponent } from './components/template-interceptor/template-interceptor.component';
import { NgxSpinnerModule } from './components/ngx-spinner/ngx-spinner.module';
import { FreeHandWrittingComponent } from './components/free-hand-writting/free-hand-writting.component';
// import { FreeHandWrittingDirective } from './directive/free-hand-writting.directive';
import { SpeedTestComponent } from './components/speedtest/speedtest.component';
import { RangeSliderComponent } from './components/range-slider/range-slider.component';
import { EventCalendarComponent } from './components/event-calendar/event-calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarEventDetailComponent } from './components/event-calendar/calendar-event-detail/calendar-event-detail.component';
import { HotkeysService } from './services/hotkeys.service';
import { ScreenShortcutsComponent } from './components/screen-shortcuts/screen-shortcuts.component';
import { ImageViewComponent } from './components/file-uploader/show-image/image-view.component';
import { TagRowComponent } from './components/tag-row/tag-row.component';
import { SelectProfileComponent } from './components/select-profile/select-profile.component';
import { ApproveRequestComponent } from './components/approve-request/approve-request.component';
import { PushableComponent } from './components/pushable/pushable.component';
import { PushableService } from './components/pushable/pushable.service';

import { DayViewSchedulerComponent } from './components/event-calendar/day-view-schedular/day-view-schedular.component';
import { AuditLogComponent } from './components/audit-log/audit-log.component';
import { FieldVisibilityService } from './services/fieldVisibilityOnBlockChange.service';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { ClickPhotoComponent } from './components/file-uploader/click-photo/click-photo.component';
import { SortDataPipe } from './pipes/sort-data.pipe';
import { OpdTypeSelectionComponent } from './components/opd-type-selection/opd-type-selection.component';
import { CameraAudioPermssionComponent } from './components/permission/camera-audio-permssion.component';
import { DashboardModule } from './components/dash-board/dashboard.module';
import { ChartComponent } from './components/dash-board/components/chart/chart.component';
import { ChartDoughnutComponent } from './components/dash-board/components/chart-doughnut/chart-doughnut.component';
import { ColortoHexPipe } from './pipes/color.pipe';
import { AunthicationFlagComponent } from './components/aunthication-flag/aunthication-flag.component';
import { ConfigureUiEngineComponent } from './components/ui-engine/configure-uiengine/configure-uiengine.component';
import { JsonViewerComponent } from './components/viewer/json-viewer/json-viewer.component';
import { HtmlViewerComponent } from './components/viewer/html-viewer/html-viewer.component';
import { EditGridOverPopUpComponent } from './components/editable-grid/edit-grid-over-pop-up/edit-grid-over-pop-up.component';
import { CsvJsonDownloadComponent } from './components/csv-json-download/csv-json-download.component';
import { TicketsComponent } from './components/tickets/tickets.component';
import { TextToSpeechComponent } from './components/text-to-speech/text-to-speech.component';
import { QrCodeScannerComponent } from './components/qr-code-reader/qr-code-scanner.component';
import { AbhaPatientRegisterComponent } from './components/abha-patient-register/abha-patient-register.component';
import { DomainPlatformComponent } from './components/domain-platform/domain-platform.component';
import { QrCodeGeneratorComponent } from './components/qr-code-reader/qr-code-generator/qr-code-generator.component';
import { S3ViewerComponent } from './components/viewer/s3-viewer/s3-viewer.component';
import { TemplateReportsComponent } from './template-reports/template-reports.component';
import { CatalogCardComponent } from './components/catalog-card/catalog-card.component';
import { CKEditorModule } from './shared_modules/ng2-ckeditor/ckeditor.module';
import { BulkEntryMainComponent } from './components/bulk-entry-main/bulk-entry-main.component';
import { ExternalRedirectComponent } from './components/external-redirect/external-redirect.component';

import { SignatureComponent } from './components/signature/signature.component';
import { VoiceSearchComponent } from './components/voice-search/voice-search.component';
import { ArchivalEngineComponent } from './components/archival-engine/archival-engine.component';
import { TesseractComponent } from './components/tesseract/tesseract.component';
import { IntlTelInputComponent } from './components/intl-tel-input/intl-tel-input.component';
import { SelectProfileExtendedComponent } from './components/select-profile-extended/select-profile-extended.component';
import { FilterNamePipe } from './components/select-profile-extended/select-profile-pipe/filter-name.pipe';
import { AsideBarTabsComponent } from './components/aside-bar-tabs/aside-bar-tabs.component';
import { DiagnosticRisReportsComponent } from './diagnostic-reports/diagnostic-ris-reports/diagnostic-ris-reports.component';
import { AssessmentFormComponent } from './components/assessment-form/assessment-form.component';
import { AssessmentFormQuestionComponent } from './components/assessment-form/assessment-form-question.component';
import { AssessmentEngineComponent } from './components/assessment-engine/assessment-engine.component';
import { AssessmentFormService } from './components/assessment-form/assessment-form.service';
import { TextEntryQuestionComponent } from './components/assessment-form/questions/textentry-question.component';
import { SingleChoiceQuestionComponent } from './components/assessment-form/questions/single-choice-question.component';
import { ConsentCheckComponent } from './components/consent-check/consent-check.component';
import { AvighnaResultComponent } from './components/dash-board/components/avighna-result/avighna-result.component';
import { LeaveCalendarComponent } from './components/leave-calendar/leave-calendar/leave-calendar.component';
import { NgxIntlTelInputModule } from './components/intl-tel-input/ngx-intl-tel-input/ngx-intl-tel-input.module';
import { PrintPopupComponent } from './components/data-grid/print-popup/print-popup.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { ResourceLoaderComponent } from './components/resource-loader/resource-loader.component';
import { ChatbotService } from './components/chatbot/chatbot.service';
import { ShowSubstitutesComponent } from './components/show-substitutes/show-substitutes.component';
import { AutoClickComponentComponent } from './components/file-uploader/auto-click-component/auto-click-component.component';
import { Icd11Component } from './components/icd-11/icd-11.component';
import { AiMlModule } from './components/aiml/aiml.module';
import { FingerprintCaptureComponent } from './components/fingerprint-capture/fingerprint-capture.component';
import { BiometricAuthComponent } from './components/biometric-auth/biometric-auth.component';
import { CyclicTreatmentComponent } from './components/cyclic-treatment/cyclic-treatment.component';
import { FingerprintComponent } from './components/fingerprint/fingerprint.component';
import { ImageRendererComponent } from './components/ImageRendererComponent/image-renderer.component';
import { SummaryEngineComponent } from './components/summary-engine/summary-engine.component';
import { DecimalCurrencyPipe } from './pipes/decimal-currency.pipe';
import { MapValueSummaryPipe } from './pipes/map-value-summary.pipe';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { ImageEditorComponent } from './components/image-editor/image-editor.component';
import { ConvoxPatientMobileComponent } from './components/convox-patient-mobile/convox-patient-mobile.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { Ng2PdfjsViewerComponent } from './components/Ng2Pdfjs/ng2-pdfjs-viewer.component';
import { FloatingHostComponent } from './components/floating-host/floating-host.component';
import { FloatingOverlayService } from './components/floating-host/floating-overlay.service';
import { MobileCardTemplateViewComponent } from './components/viewer/mobile-card-template-view/mobile-card-template-view.component';
import { KxAiChatEmbedComponent } from './components/kx-ai-chat-embed/kx-ai-chat-embed.component';
import { ChatbotWidgetComponent } from './components/chatbot-widget/chatbot-widget.component';
import { SharedPopoverDirective } from './directive/shared-popover.directive';
import { OutsideSafeHtmlDirective } from './pipes/ngOutsideHTML.pipe';
import { ReleaseNoteComponent } from './components/release-note/release-note.component';
import { ChemotherapyProtocolComponent } from './components/chemotherapy-protocol/chemotherapy-protocol.component';
import { StimulationChart } from './components/stimulation-chart/stimulation-chart.component';
import { OrderServiceComponent } from './components/order-service/order-service.component';
import { FollicularChartGridComponent } from './components/follicular-chart-grid/follicular-chart-grid.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';

@NgModule({ declarations: [
     SharedPopoverDirective,
        PopupFormComponent,
        ConfirmModalComponent,
        EmrTemplateViewComponent,
        MainComponent,
        FormComponent,
        FormDirective,
        FormQuestionComponent,
        SummaryEngineComponent,
        DataGridComponent,
        DataGridPaginationComponent,
        UiEngineComponent,
        ConfigureUiEngineComponent,
        ResourcePopupComponent,
        CheckboxComponent,
        MultiDropdownComponent,
        OnCreate,
        DecimalCurrencyPipe,
        KeysPipe,
        AddressPipe,
        FacilityObjPipe,
        PropertyPipe,
        CompositeArrayComponent,
        CompositeArrayObjectComponent,
        HandleRouteComponent,
        BaseComponent,
        FormWithGridComponent,
        MapValueSummaryPipe,
        InputButtonComponent,
        InputButtonPopupComponent,
        FileUploaderComponent,
        HideMenuOverlay,
        DynamicPopUpComponent,
        ...APP_CONTAINERS,
        PopUpOverGridWithControlsComponent,
        DropdownComponent,
        DropdownObjectComponent,
        ResourceBannerComponent,
        WidgetCardComponent,
        DataGridWidgetComponent,
        WidgetComponent,
        DateTimeFilterComponent,
        FormViewComponent,
        FormViewItemComponent,
        ChartGroupComponent,
        DashBoardComponent,
        SimpleDataTableComponent,
        FormGridComponent,
        LanguageSelectionComponent,
        CloseOverlayDirective,
        scrollOverlayDirective,
        ImageViewerComponent,
        ToggleFullscreenDirective,
        ViewTemplateComponent,
        DateFormatPipe,
        MapValuePipe,
        MaskPipe,
        GetHeightPipe,
        MonthYearFormatPipe,
        DocumentPipe,
        SafeHtml,
        OrderByPipe,
        SafeStyleHtml,
        DocumentViewerComponent,
        ScrollDirective,
        DateTimeFormatPipe,
        UserProfileComponent,
        TimeFormatPipe,
        TagInputComponent,
        BookmarksComponent,
        EditableTableComponent,
        LabelControl,
        RatingComponent,
        ViewResourceComponent,
        ScoreComponent,
        PullableComponent,
        FilterComponent,
        EditableGridComponent,
        ThumbViewerComponent,
        NumberDirective,
        TncComponent,
        EditableGridWithBannerComponent,
        RangeComponent,
        PopupEditableGridWithBannerComponent,
        PDFViewerComponent,
        EulaComponent,
        DiacomViewerComponent,
        CartComponent,
        CatalogCardComponent,
        InclusionExclusionComponent,
        DateTimeViewComponent,
        NgxModalDraggableDirective,
        TextareaResizeDirective,
        DashboardMasterComponent,
        DashboardSidebarComponent,
        CountComponent,
        DynamicDashboardComponent,
        CompositeChartComponent,
        TokenComponent,
        ComplexSearchComponent,
        PopUIEngineComponent,
        NgMonthPickerComponent,
        ClickOutsidemonthyearDirective, MonthYearViewComponent, AdvanceSearchComponent,
        PatientUhidMergeSearchComponent,
        ImageCropperComponent,
        DownloadPopupComponent,
        PrintPopupComponent,
        DownloadInfoComponent,
        EncounterpopupComponent,
        DataGridRowEditComponent,
        AsideUiEngineComponent,
        SearchPatientComponent,
        PatientPopupComponent,
        ShowPdfComponent,
        DocumentWithThumbnailComponent,
        CommonViewerComponent,
        ManageFilterComponent,
        DynamicTableComponent,
        AppAlertComponent,
        BaseChartDirective,
        IsMobileEditableGridComponent,
        MultipleFormComponent,
        DocumentViewerWithThumbnailComponent,
        TemplateInterceptorComponent,
        TicketsComponent,
        FreeHandWrittingComponent,
        // FreeHandWrittingDirective,
        SpeedTestComponent,
        RangeSliderComponent,
        EventCalendarComponent,
        CalendarEventDetailComponent,
        ScreenShortcutsComponent,
        ImageViewComponent,
        TagRowComponent,
        SelectProfileComponent,
        ApproveRequestComponent,
        PushableComponent,
        DayViewSchedulerComponent,
        AuditLogComponent,
        CurrencyPipe,
        ColortoHexPipe,
        VideoPlayerComponent,
        ClickPhotoComponent,
        SortDataPipe,
        CameraAudioPermssionComponent,
        OpdTypeSelectionComponent,
        ChartComponent,
        ChartDoughnutComponent,
        AunthicationFlagComponent,
        JsonViewerComponent,
        HtmlViewerComponent,
        EditGridOverPopUpComponent,
        CsvJsonDownloadComponent,
        TextToSpeechComponent,
        QrCodeScannerComponent,
        AbhaPatientRegisterComponent,
        DomainPlatformComponent,
        QrCodeGeneratorComponent,
        S3ViewerComponent,
        IcdSearchComponent,
        TemplateReportsComponent,
        BulkEntryMainComponent,
        ExternalRedirectComponent,
        SignatureComponent,
        VoiceSearchComponent,
        ArchivalEngineComponent,
        TesseractComponent,
        IntlTelInputComponent,
        SelectProfileExtendedComponent,
        FilterNamePipe,
        AsideBarTabsComponent,
        DiagnosticRisReportsComponent,
        QuickDownloadComponent,
        AssessmentEngineComponent,
        AssessmentFormComponent,
        AssessmentFormQuestionComponent,
        TextEntryQuestionComponent,
        SingleChoiceQuestionComponent,
        ConsentCheckComponent,
        ConvoxPatientMobileComponent,
        AvighnaResultComponent,
        LeaveCalendarComponent,
        ChatbotComponent,
        ResourceLoaderComponent,
        ShowSubstitutesComponent,
        AutoClickComponentComponent,
        Icd11Component,
        FingerprintCaptureComponent,
        BiometricAuthComponent,
        CyclicTreatmentComponent,
        FingerprintComponent,
        ImageRendererComponent,
        FileManagerComponent,
        ImageEditorComponent,
        Ng2PdfjsViewerComponent,
        FloatingHostComponent,
        MobileCardTemplateViewComponent,
        KxAiChatEmbedComponent,
        ChatbotWidgetComponent,
        OutsideSafeHtmlDirective,
        ReleaseNoteComponent,
        ChemotherapyProtocolComponent,
        StimulationChart,
        OrderServiceComponent,
        FollicularChartGridComponent,
        AccessibilityComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    exports: [
        CommonViewerComponent,
        S3ViewerComponent,
        IcdSearchComponent,
        PopupFormComponent,
        ConfirmModalComponent,
        PopupEditableGridWithBannerComponent,
        EmrTemplateViewComponent,
        UiEngineComponent,
        ConfigureUiEngineComponent,
        ResourcePopupComponent,
        NgxDaterangepickerMd,
        MainComponent,
        MapValueSummaryPipe,
        FormComponent,
        CheckboxComponent,
        FormQuestionComponent,
        DataGridComponent,
        DataGridPaginationComponent,
        MultiDropdownComponent,
        CommonModule,
        SelectProfileExtendedComponent,
        NgMultiSelectDropDownModule,
        CompositeArrayComponent,
        CompositeArrayObjectComponent,
        HandleRouteComponent,
        BaseComponent,
        FreeHandWrittingComponent,
        FormWithGridComponent,
        AppAsideModule,
        AppBreadcrumbModule,
        AppHeaderModule,
        AppFooterModule,
        AppSidebarModule,
        PopUpOverGridWithControlsComponent,
        DropdownComponent,
        DropdownObjectComponent,
        ResourceBannerComponent,
        WidgetCardComponent,
        WidgetComponent,
        DataGridWidgetComponent,
        DateTimeFilterComponent,
        FormViewComponent,
        FormViewItemComponent,
        ChartGroupComponent,
        DashBoardComponent,
        SimpleDataTableComponent,
        FormGridComponent,
        KeysPipe,
        AddressPipe,
        FacilityObjPipe,
        DecimalCurrencyPipe,
        PropertyPipe,
        LanguageSelectionComponent,
        ImageViewerComponent,
        ToggleFullscreenDirective,
        SafeHtml,
        OrderByPipe,
        SafeStyleHtml,
        ScrollDirective,
        CloseOverlayDirective,
        scrollOverlayDirective,
        DocumentViewerComponent,
        OnCreate,
        FormDirective,
        DateTimeFormatPipe,
        BookmarksComponent,
        EditableTableComponent,
        FileUploaderComponent,
        DateFormatPipe,
        MapValuePipe,
        MaskPipe,
        MonthYearFormatPipe,
        DocumentPipe,
        TimeFormatPipe,
        ScoreComponent,
        TranslateModule, PopoverModule,
        EditableGridComponent,
        ThumbViewerComponent,
        FilterComponent,
        EditableGridWithBannerComponent,
        PDFViewerComponent,
        EulaComponent,
        SummaryEngineComponent,
        DiacomViewerComponent,
        CartComponent,
        CatalogCardComponent,
        NgMonthPickerComponent,
        InclusionExclusionComponent,
        NgxModalDraggableDirective,
        TextareaResizeDirective,
        DashboardMasterComponent,
        CompositeChartComponent,
        ComplexSearchComponent,
        ClickOutsidemonthyearDirective,
        InputButtonComponent,
        TagInputComponent,
        RatingComponent,
        PullableComponent,
        RangeComponent,
        PatientUhidMergeSearchComponent,
        ImageCropperComponent,
        DownloadPopupComponent,
        PrintPopupComponent,
        DownloadInfoComponent,
        DataGridRowEditComponent,
        ShowPdfComponent,
        DocumentWithThumbnailComponent,
        CKEditorModule,
        ManageFilterComponent,
        AppAlertComponent,
        BaseChartDirective,
        IsMobileEditableGridComponent,
        GetHeightPipe,
        DocumentViewerWithThumbnailComponent,
        SpeedTestComponent,
        ScreenShortcutsComponent,
        RangeSliderComponent,
        SelectProfileComponent,
        ApproveRequestComponent,
        CurrencyPipe,
        ColortoHexPipe,
        CameraAudioPermssionComponent,
        DayViewSchedulerComponent,
        ChartComponent,
        ChartDoughnutComponent,
        AunthicationFlagComponent,
        JsonViewerComponent,
        HtmlViewerComponent,
        SortDataPipe,
        DomainPlatformComponent,
        TemplateReportsComponent,
        ExternalRedirectComponent,
        SignatureComponent,
        IntlTelInputComponent,
        AsideBarTabsComponent,
        QuickDownloadComponent,
        AssessmentEngineComponent,
        LeaveCalendarComponent,
        AssessmentFormComponent,
        AssessmentFormQuestionComponent,
        TextEntryQuestionComponent,
        SingleChoiceQuestionComponent,
        AvighnaResultComponent,
        ResourceLoaderComponent,
        Icd11Component,
        AiMlModule,
        FingerprintCaptureComponent,
        BiometricAuthComponent,
        CyclicTreatmentComponent,
        FileManagerComponent,
        Ng2PdfjsViewerComponent,
        FloatingHostComponent,
        Ng2PdfjsViewerComponent,
        VideoPlayerComponent,
        ChemotherapyProtocolComponent,
        StimulationChart,
        OrderServiceComponent,
        FollicularChartGridComponent,
        KxAiChatEmbedComponent,
        ChatbotWidgetComponent
    ], imports: [CommonModule,
        RouterModule,
        BaseSharedModule,
        FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        ModalModule.forRoot(),
        ToastrModule.forRoot(),
        NgxSpinnerModule,
        DialogModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        NgMultiSelectDropDownModule,
        NgxDaterangepickerMd.forRoot(),
        PopoverModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        AppAsideModule,
        AppFooterModule,
        AppHeaderModule,
        AppSidebarModule,
        // PerfectScrollbarModule,
        TabsModule,
        TimePickerModule,
        CKEditorModule,
        TranslateModule,
        DashboardModule,
        AiMlModule,
        GridsterModule,
        NgxIntlTelInputModule,
        NgxExtendedPdfViewerModule], providers: [
        FormService,
        QuestionControlService,
        UtilService,
        // AccessibilityService is deliberately NOT listed here — it is already
        // `providedIn: 'root'`. Listing it as well re-registered it in the injector of every
        // lazy-loaded module that pulls in BaseModule (26 of them, via KxSharedModule), so a
        // resolution through any of those built a *second* service. Each instance appends its
        // own color-filter overlay and reading-mask panels to <body>: two stacked
        // `backdrop-filter: invert(1)` layers cancel out (page looks normal, toggle still reads
        // "on") and "Reset all" on one instance can't remove the other's elements. See #201077
        // and reconcileEffectEl() in accessibility.service.ts.
        DateFormatPipe,
        MapValuePipe,
        MaskPipe,
        MonthYearFormatPipe,
        DocumentPipe,
        GetHeightPipe,
        DecimalCurrencyPipe,
        SmartModalService,
        ModalService,
        MapValueSummaryPipe,
        BsModalService,
        AsideBarService,
        ShareMultiDropDownData,
        QuestionControlService,
        UtilService,
        AlertsService,
        LoaderService,
        CommonResolverService,
        TabsService,
        exportImportFilesService,
        editableGridService,
        HotkeysService,
        ApplicationInitService,
        CommunicationService,
        AsyncValidationService,
        DateTimeFilterService,
        ChartService,
        StatusService,
        FilterService,
        EditableGridWithBannerService,
        NgxImageCompressService,
        KeysPipe,
        AddressPipe,
        FacilityObjPipe,
        PropertyPipe,
        DialogConfig,
        DialogRef,
        PushableService,
        FieldVisibilityService,
        CurrencyPipe,
        ColortoHexPipe,
        BsModalRef,
        AssessmentFormService,
        ChatbotService,
        FileManagerComponent,
        FloatingOverlayService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class BaseModule {
  public entryComponents: any = [
    BulkEntryMainComponent,
    AsideUiEngineComponent,
    DataGridRowEditComponent,
    PopupFormComponent,
    VoiceSearchComponent,
    QrCodeGeneratorComponent,
    SummaryEngineComponent,
    ConfirmModalComponent,
    PopupEditableGridWithBannerComponent,
    UiEngineComponent,
    ConfigureUiEngineComponent,
    ResourceBannerComponent,
    CompositeArrayObjectComponent,
    ViewTemplateComponent,
    HandleRouteComponent,
    EventCalendarComponent,
    BaseComponent,
    FormWithGridComponent,
    InputButtonComponent,
    InputButtonPopupComponent,
    DynamicPopUpComponent,
    PopUpOverGridWithControlsComponent,
    DropdownObjectComponent,
    DataGridComponent,
    DateTimeFilterComponent,
    FormComponent,
    DashBoardComponent,
    SimpleDataTableComponent,
    FormGridComponent,
    DocumentViewerComponent,
    UserProfileComponent,
    DataGridWidgetComponent,
    CalendarEventDetailComponent,
    BookmarksComponent,
    EditableTableComponent,
    ViewResourceComponent,
    ScoreComponent,
    EditableGridComponent,
    ImageViewerComponent,
    TncComponent,
    EmrTemplateViewComponent,
    EditableGridWithBannerComponent,
    PDFViewerComponent,
    EulaComponent,
    DiacomViewerComponent,
    CartComponent,
    CatalogCardComponent,
    InclusionExclusionComponent,
    DateTimeViewComponent,
    DashboardMasterComponent,
    DashboardSidebarComponent,
    CountComponent,
    DynamicDashboardComponent,
    CompositeChartComponent,
    ComplexSearchComponent,
    PopUIEngineComponent,
    TagInputComponent,
    RangeComponent,
    AdvanceSearchComponent,
    MultiDropdownComponent,
    PatientUhidMergeSearchComponent,
    ImageCropperComponent,
    DownloadPopupComponent,
    PrintPopupComponent,
    DownloadInfoComponent,
    EncounterpopupComponent,
    SearchPatientComponent,
    PatientPopupComponent,
    ShowPdfComponent,
    DocumentWithThumbnailComponent,
    CommonViewerComponent,
    S3ViewerComponent,
    IcdSearchComponent,
    ManageFilterComponent,
    DynamicTableComponent,
    AppAlertComponent,
    DocumentViewerWithThumbnailComponent,
    TemplateInterceptorComponent,
    SpeedTestComponent,
    TicketsComponent,
    ScreenShortcutsComponent,
    RangeSliderComponent,
    TagRowComponent,
    SelectProfileExtendedComponent,
    SelectProfileComponent,
    ApproveRequestComponent,
    DayViewSchedulerComponent,
    ClickPhotoComponent,
    CameraAudioPermssionComponent,
    AuditLogComponent,
    ChartComponent,
    ChartDoughnutComponent,
    AunthicationFlagComponent,
    DayViewSchedulerComponent,
    HtmlViewerComponent,
    CsvJsonDownloadComponent,
    TextToSpeechComponent,
    TemplateReportsComponent,
    ExternalRedirectComponent,
    SignatureComponent,
    FilterNamePipe,
    ArchivalEngineComponent,
    IntlTelInputComponent,
    AsideBarTabsComponent,
    DiagnosticRisReportsComponent,
    QuickDownloadComponent,
    AssessmentEngineComponent,
    LeaveCalendarComponent,
    AssessmentFormComponent,
    AssessmentFormQuestionComponent,
    TextEntryQuestionComponent,
    SingleChoiceQuestionComponent,
    ConsentCheckComponent,
    ConvoxPatientMobileComponent,
    AvighnaResultComponent,
    ResourceLoaderComponent,
    ShowSubstitutesComponent,
    Icd11Component,
    FingerprintCaptureComponent,
    BiometricAuthComponent,
    CyclicTreatmentComponent,
    FingerprintComponent,
    FileUploaderComponent,
    ImageRendererComponent,
    FileManagerComponent,
    ImageEditorComponent,
    Ng2PdfjsViewerComponent,
    FloatingHostComponent,
    MobileCardTemplateViewComponent,
    ChemotherapyProtocolComponent,
    StimulationChart,
    OrderServiceComponent,
    FollicularChartGridComponent,
    AccessibilityComponent
  ]
  public appService: AppService;
  constructor(public injector: Injector) {
    this.appService = injector.get(AppService);
    this.appService._factories["modules"]["BaseModule"] = this.entryComponents;
    if (this.entryComponents && this.entryComponents.length) {
      this.appService.buildFactory(this.entryComponents);
    }
  }
}
